var _path, _path2, _rect, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlameUsdtLp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C40.8362 0 48 7.16384 48 16C48 24.8362 40.8358 32 32 32C23.1642 32 16 24.8381 16 16C16 7.16192 23.1629 0 32 0Z",
    fill: "#53AE94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9747 13.8685V11.4884H39.4176V7.86182H24.5964V11.4884H30.04V13.8666C25.616 14.0698 22.2896 14.946 22.2896 15.9956C22.2896 17.0452 25.6176 17.9213 30.04 18.1258V25.7498H33.976V18.1252C38.392 17.9213 41.7116 17.0458 41.7116 15.9972C41.7116 14.9485 38.392 14.073 33.976 13.8692L33.9747 13.8685ZM33.976 17.4794V17.4775C33.8649 17.4845 33.2944 17.5188 32.024 17.5188C31.0083 17.5188 30.2937 17.49 30.0419 17.4769V17.4801C26.1334 17.3069 23.216 16.6263 23.216 15.8119C23.216 14.9975 26.1337 14.3178 30.0419 14.1444V16.802C30.2979 16.8196 31.03 16.8628 32.0406 16.8628C33.2544 16.8628 33.8646 16.8122 33.9766 16.802V14.1444C37.8774 14.3181 40.7881 14.9994 40.7881 15.8109C40.7881 16.6225 37.8761 17.3041 33.9766 17.4778",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9210_18206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 15,
    width: 34,
    height: 34
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 32,
    r: 16.5,
    fill: "#C4C4C4",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9210_18206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4122 40.693C7.07874 38.2909 5.82179 34.4669 7.98602 30.4075C8.12868 30.1399 8.55295 30.2345 8.64133 30.5245C8.95702 31.5606 9.59714 32.0777 9.59714 32.0777C9.39353 31.6079 8.60163 26.5352 12.4223 24.2023C12.6448 24.0665 12.9167 24.2676 12.8821 24.5258C12.7083 25.8248 12.5787 28.6125 14.8389 27.8298C16.8891 27.1198 15.4157 23.4096 14.662 21.8001C14.5394 21.5384 14.8013 21.2478 15.069 21.3571C19.6104 23.2119 23.1636 26.2365 21.88 31.7128C22.2184 31.7763 23.329 31.5825 23.9591 30.6725C24.1238 30.4346 24.5034 30.4239 24.5857 30.7013C25.2091 32.8025 26.1348 38.3228 21.1859 41.2446C20.9068 40.543 20.3665 40.0134 20.1618 39.8464C20.1107 39.8047 20.062 39.8192 20.0227 39.8721C19.8289 40.1332 19.179 40.9433 18.5419 40.9925C17.366 41.0832 16.7104 39.8055 16.9981 38.4125C17.0305 38.2556 16.8899 38.1089 16.7372 38.158C14.8845 38.7549 14.4017 39.9866 14.4017 39.9866C13.5997 39.3347 12.8902 38.1278 13.0405 35.3849C13.0518 35.1789 12.7947 35.0814 12.6798 35.2528C11.953 36.337 10.5218 38.7057 10.4122 40.693Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameUsdtLp);
export default __webpack_public_path__ + "static/media/flame-usdt-lp.74c921b16ba8581e07e97b547398e146.svg";
export { ForwardRef as ReactComponent };